import { PublicKey } from "@solana/web3.js";

export async function findAssociatedStakeInfoAddress(
  poolId: PublicKey,
  walletAddress: PublicKey,
  programId: PublicKey,
) {
  const { publicKey } = await findProgramAddress(
    [poolId.toBuffer(), walletAddress.toBuffer(), Buffer.from("staker_info_v2_associated_seed")],
    programId,
  );
  return publicKey;
}

export async function findProgramAddress(seeds: Array<Buffer | Uint8Array>, programId: PublicKey) {
  const [publicKey, nonce] = await PublicKey.findProgramAddress(seeds, programId);
  return { publicKey, nonce };
}
